/**
 * 2007-2017 PrestaShop
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License 3.0 (AFL-3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to http://www.prestashop.com for more information.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright 2007-2017 PrestaShop SA
 * @license   https://opensource.org/licenses/AFL-3.0 Academic Free License 3.0 (AFL-3.0)
 * International Registered Trademark & Property of PrestaShop SA
 */
import $ from 'jquery';
import prestashop from 'prestashop';
import SlickSlider from './components/slick';
/*tab produit sticky*/
var Sticky = require('sticky-js');

$(document).ready(function () {
//  createProductSpin();

  createInputFile();
  let slickSlider = new SlickSlider();
  $('[data-toggle="tooltip"]').tooltip();
  autoPlayYouTubeModal();
  var $navbar = $('.navTabs');
	var $navbara = $('.nav-link', $navbar); 
  
	var sticky = new Sticky('.navTabs');
	$navbara.click(function(e){
			e.preventDefault();
			$('html, body').animate({
			scrollTop: $($(this).attr('href')).offset().top- $navbar.height()
			},1200);
		});

 
 $('body#product').scrollspy({ target: '#scrollspyNavProducts' });

  prestashop.on('updatedProduct', function (event) {
      createInputFile();


      if (event && event.product_minimal_quantity) {
      const minimalProductQuantity = parseInt(event.product_minimal_quantity, 10);
      const quantityInputSelector = '#quantity_wanted';
      let quantityInput = $(quantityInputSelector);

      // @see http://www.virtuosoft.eu/code/bootstrap-touchspin/ about Bootstrap TouchSpin
      quantityInput.trigger('touchspin.updatesettings', {min: minimalProductQuantity});
    }
    $($('.tabs .nav-link.active').attr('href')).addClass('active').removeClass('fade');
    $('.js-product-images-modal').replaceWith(event.product_images_modal);
    slickSlider.init();

  });


  function createInputFile()
  {
    $('.js-file-input').on('change', (event) => {
      let target, file;

      if ((target = $(event.currentTarget)[0]) && (file = target.files[0])) {
        $(target).prev().text(file.name);
      }
    });
  }

    function createProductSpin()
    {
        const $quantityInput = $('#quantity_wanted');

        $quantityInput.TouchSpin({
            buttondown_class: 'btn js-touchspin',
            buttonup_class: 'btn js-touchspin',
            min: parseInt($quantityInput.attr('min'), 10),
            max: 1000000
        });

        $('body').on('change keyup', '#quantity_wanted', (e) => {
            $(e.currentTarget).trigger('touchspin.stopspin');
            prestashop.emit('updateProduct', {
                eventType: 'updatedProductQuantity',
                event: e
            });
        });

    }
    
    /*sur mobile voir plus de texte dans la description courte*/  
		if (prestashop.responsive.mobile){
			$(".product-description-short .btn").click(function(e) {
				var status = $(".product-description-short").hasClass("open");
				if(!status){
					$(".product-description-short").addClass("open");		
					$(".product-description-short li").show("slow");
				}
				else{
					$(".product-description-short ul>li:nth-child(2)~li").hide(1000);		
					$(".product-description-short").removeClass("open");		
				}
			});
   } 
   
   
    function autoPlayYouTubeModal(){
		  $('body#product .target-modal-video').click(function() {
		    var theModal = $(this).data( "target" ),
		    videoSRC = $(this).attr( "data-theVideo" );
		    $(theModal+' .modal-body').html('<iframe width="100%" height="600" src="" allowfullscreen="allowfullscreen"></iframe>');
		    $(theModal+' iframe').attr('src', '');
		    $(theModal+' iframe').attr('src', videoSRC);
		    $(theModal+' button.close').click(function () {
		        $(theModal+' iframe').attr('src', '');
		    }); 
		   
  	});
}
   

   
   
   

});

$(document).on('shown.bs.modal','#product-modal', function (e) {
/* ajout pour cibler ouverture modal*/

		var slidesToScroll=$(e.relatedTarget).attr('data-slick-slidesToScroll');

		$('#js-slick-product').slick('slickGoTo', slidesToScroll, true);

/*END� ajout pour cibler ouverture modal*/
    $('#js-slick-product').resize();
});

$(document).on('shown.bs.collapse','#product .tab', function (e) {
    $('.slick-slider').slick('refresh');
});

//add to cart loader
$(document).on('click','.js-add-to-cart:enabled:not(.is--loading)',function(){
    $(this).addClass('is--loading').attr("disabled", true);
});
prestashop.on('updateCart', function (event) {
    removeAddToCartLoader();

});
prestashop.on('handleError', function (event) {
    removeAddToCartLoader();
    $('.js-add-to-cart').attr("disabled", false);

});
function removeAddToCartLoader(){
    $('.js-add-to-cart.is--loading').removeClass('is--loading');

}